import * as Yup from "yup";

const regExpOnlyLetter = /^[ñíóáéú a-zA-Z ]+$/;
const RegExpEmail = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
const NumberRegExp = /^[0-9 ]*$/;
const PhoneRegExp = /^[0-9 ]\d{6,9}$/;
const WhatsAppRegExp = /\+\d{1,3} \d{6,15}/;
const DateRegExp = /^([0-9][0-9][0-9][0-9])-([0][1-9]|[1][0-2])-([0-2][0-9]|[3][0-1])$/;

export const validationAffiliationToHealth = Yup.object().shape({
  documentNumber: Yup.string()
    .matches(NumberRegExp, "Por favor escriba un número de documento válido, solo números.")
    .required("Campo obligatorio.")
    .max(20, "Máximo 20 números."),
  email: Yup.string()
    .matches(RegExpEmail, "Escriba un email válido. ejemplo: foo-bar.baz@example.com")
    .required("Campo obligatorio.")
    .max(40, "Máximo 40 caracteres."),
  name: Yup.string()
    .matches(regExpOnlyLetter, "Por favor escriba únicamente letras.")
    .required("Campo obligatorio.")
    .max(40, "Máximo 40 caracteres."),
  lastName: Yup.string()
    .matches(regExpOnlyLetter, "Por favor escriba únicamente letras.")
    .required("Campo obligatorio.")
    .max(40, "Máximo 40 caracteres."),
  phoneNumber: Yup.string()
    .matches(PhoneRegExp, "Por favor escriba un número de teléfono válido, solo números.")
    .required("Campo obligatorio."),
  secondaryPhoneNumber: Yup.string()
    .matches(PhoneRegExp, "Por favor escriba un número de teléfono válido, solo números.")
    .required("Campo obligatorio."),
  whatsAppPhoneNumber: Yup.string().matches(
    WhatsAppRegExp,
    "Por favor escriba un número de teléfono válido, solo el indicativo con el signo +, un espaciado y números.",
  ),
  birthday: Yup.string().nullable().required("Campo obligatorio.").matches(DateRegExp, "Formato de fecha no válido."),
  documentExpirationDate: Yup.string()
    .nullable()
    .required("Campo obligatorio.")
    .matches(DateRegExp, "Formato de fecha no válido."),
  neighborhood: Yup.string().max(40, "Máximo 40 caracteres."),
});
